import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { useDispatch, useSelector } from "react-redux";
import { getAppFormLibrary, getCandidateApps, loadAppFormLibrary, loadCandidateApps } from "../../app/store/candidate";
import { getCurrentUser } from "../../app/store/auth";
import ViewFormModal from "../../app/components/ViewFormModal";
import { getComponentUserStatus, UpdateComponentsUserStatus } from "../../app/store/tools";

const FORM_LIBRARY_STYLES = {
  pageWrap: {
    padding: "12px 0 4px 0"
  },
  shell: {
    borderRadius: "24px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    boxShadow: "0 18px 38px rgba(15, 23, 42, 0.06)",
    overflow: "hidden"
  },
  hero: {
    padding: "24px 24px 18px 24px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
    flexWrap: "wrap"
  },
  titleWrap: {
    minWidth: 0,
    display: "flex",
    alignItems: "flex-start",
    gap: "14px"
  },
  titleIcon: {
    width: "52px",
    height: "52px",
    borderRadius: "16px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "24px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  titleCopy: {
    minWidth: 0
  },
  eyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "10px"
  },
  title: {
    fontSize: "24px",
    fontWeight: 800,
    lineHeight: 1.15,
    color: "#0f172a",
    margin: 0
  },
  subtitle: {
    fontSize: "14px",
    lineHeight: 1.6,
    color: "#475569",
    margin: "8px 0 0 0",
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginTop: "18px"
  },
  statCard: {
    borderRadius: "18px",
    padding: "14px 16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 10px 26px rgba(37, 99, 235, 0.06)"
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px"
  },
  statValue: {
    fontSize: "26px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1
  },
  statHint: {
    fontSize: "12px",
    lineHeight: 1.5,
    color: "#64748b",
    marginTop: "6px"
  },
  body: {
    padding: "20px 24px 24px 24px"
  },
  tableWrap: {
    borderRadius: "20px",
    overflow: "auto",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff"
  },
  table: {
    marginBottom: 0
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px"
  },
  cell: {
    verticalAlign: "middle",
    padding: "16px"
  },
  serialBadge: {
    minWidth: "34px",
    height: "34px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(79, 70, 229, 0.08)",
    color: "#4338ca",
    fontSize: "13px",
    fontWeight: 800
  },
  dateText: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#0f172a"
  },
  timeText: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  personName: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "4px"
  },
  metaLine: {
    fontSize: "12px",
    lineHeight: 1.55,
    color: "#64748b"
  },
  viewButton: {
    position: "relative",
    border: "none",
    borderRadius: "999px",
    padding: "10px 14px",
    background: "rgba(37, 99, 235, 0.08)",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 800
  },
  updateBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "22px",
    height: "22px",
    borderRadius: "999px",
    marginLeft: "8px",
    background: "#ef4444",
    color: "#ffffff",
    fontSize: "11px",
    fontWeight: 800
  },
  remarksText: {
    whiteSpace: "pre-wrap",
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#475569"
  },
  emptyState: {
    padding: "42px 20px",
    textAlign: "center",
    background: "linear-gradient(180deg, rgba(248,250,252,0.8) 0%, rgba(255,255,255,1) 100%)"
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    borderRadius: "20px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(79, 70, 229, 0.08)",
    color: "#4f46e5",
    fontSize: "28px",
    marginBottom: "14px"
  },
  emptyTitle: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px"
  },
  emptyText: {
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#64748b",
    margin: "0 auto",
    textAlign: "center"
  }
};

const FormLibrary = () => {
  const route = [{ url: "", name: "Home" }];

  const [appFormLibrary, setAppFormLibrary] = useState([]);
  const [workflow, setWorkflow] = useState(null);
  const [wfTask, setWfTask] = useState(null);
  const [viewFormShowHide, setViewFormShowHide] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);

  const candidateAppsSelector = useSelector(getCandidateApps);
  const appFormLibrarySelector = useSelector(getAppFormLibrary);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Form"));
    dispatch(setCurrentRoute(route))
  }, []);

  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (candidateAppsSelector.length === 0 && currentUser?.id > 0)
      dispatch(loadCandidateApps(usrId))
  }, []);

  useEffect(() => {
    if (candidateAppsSelector.length > 0) {
      const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
      if (mainWorkflow.length > 0) {
        const wf = mainWorkflow[0];
        setWorkflow(wf);
        let usrId = currentUser.id;
        if (currentUser.linkUser)
          usrId = currentUser.linkUser;
        if (appFormLibrarySelector.length === 0)
          dispatch(loadAppFormLibrary(wf.oldWorkflowId, usrId));
      }
    }
  }, [candidateAppsSelector]);

  useEffect(() => {
    if (appFormLibrarySelector.length > 0) {
      const frmLibrary = appFormLibrarySelector
        .filter(x => x.formType !== "ACH Information" && x.formType !== "Insurance Information" && x.sendStatus === true);

      setAppFormLibrary(frmLibrary);

      if (frmLibrary.length > 0) {
        let frmItems = "";
        frmLibrary.map((x, key) => {
          if (key > 0) frmItems += ",";
          frmItems += x.id;
        })

        handleUpdateComponent(frmItems, frmLibrary[0].ciid);
      }

    }
  }, [appFormLibrarySelector]);

  const handleUpdateComponent = (compItems, ciid) => {
    const comp = componentUserStatusSelector.filter(x => x.compId === 22);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: "Forms",
      performerId: currentUser.id,
      compItems: compItems,
      ciid: ciid,
      wiid: 0,
      iiid: 0,
      compId: 22
    }
    if (compItems !== "" && compItems !== updCompItems) {
      dispatch(UpdateComponentsUserStatus(compObj));
    }
  }

  const handleFormShowHide = (f) => {
    if (f === "save") {
      setViewFormShowHide(false);
      setSelectedForm(null);
      setWfTask(null);
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      if (workflow)
        dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
    } else {
      setViewFormShowHide(!viewFormShowHide);
      if (f?.ciid > 0) {
        setSelectedForm(f);
        const task = { ciid: f.ciid, wiid: f.wiid, iiid: f.iiid, };
        setWfTask(task)
      }
      else {
        setSelectedForm(null);
      }
    }
  };

  const handleFormUpdate = () => {
    // if (workflow)
    //     dispatch(loadAppFormLibrary(workflow.oldWorkflowId, currentUser.id));
    if (selectedForm?.ciid) {
      //const task = {ciid: selectedForm.ciid, wiid: selectedForm.wiid,iiid: selectedForm.iiid,};
      //setWfTask(task)
      //dispatch(loadApplication(selectedForm.ciid));
    }

  }

  const totalForms = appFormLibrary.length;
  const pendingUpdates = appFormLibrary.reduce((count, item) => count + (item.updatedCount || 0), 0);
  const distinctReviewers = new Set(appFormLibrary.map((item) => item.performerName).filter(Boolean)).size;

  return (
    <React.Fragment>
      <div className="col-md-12" style={FORM_LIBRARY_STYLES.pageWrap}>
        <div style={FORM_LIBRARY_STYLES.shell}>
          <div style={FORM_LIBRARY_STYLES.hero}>
            <div style={FORM_LIBRARY_STYLES.heroRow}>
              <div style={FORM_LIBRARY_STYLES.titleWrap}>
                <div style={FORM_LIBRARY_STYLES.titleIcon}>
                  <i className="fa fa-files-o" aria-hidden="true"></i>
                </div>
                <div style={FORM_LIBRARY_STYLES.titleCopy}>
                  <h1 style={FORM_LIBRARY_STYLES.title}>Form Library</h1>
                  <p style={FORM_LIBRARY_STYLES.subtitle}>
                    Review shared forms, open the latest updates, and keep track of which reviewers have sent materials for your workflow.
                  </p>
                </div>
              </div>
            </div>
            <div style={FORM_LIBRARY_STYLES.statsRow}>
              <div style={FORM_LIBRARY_STYLES.statCard}>
                <div style={FORM_LIBRARY_STYLES.statLabel}>Available Forms</div>
                <div style={FORM_LIBRARY_STYLES.statValue}>{totalForms}</div>
                <div style={FORM_LIBRARY_STYLES.statHint}>Forms currently shared with you in this library.</div>
              </div>
              <div style={FORM_LIBRARY_STYLES.statCard}>
                <div style={FORM_LIBRARY_STYLES.statLabel}>Pending Updates</div>
                <div style={FORM_LIBRARY_STYLES.statValue}>{pendingUpdates}</div>
                <div style={FORM_LIBRARY_STYLES.statHint}>New or updated form changes ready to review.</div>
              </div>
              <div style={FORM_LIBRARY_STYLES.statCard}>
                <div style={FORM_LIBRARY_STYLES.statLabel}>Reviewers</div>
                <div style={FORM_LIBRARY_STYLES.statValue}>{distinctReviewers}</div>
                <div style={FORM_LIBRARY_STYLES.statHint}>Distinct reviewers who shared forms in this list.</div>
              </div>
            </div>
          </div>
          <div style={FORM_LIBRARY_STYLES.body}>
            <div style={FORM_LIBRARY_STYLES.tableWrap}>
              <div className="table-responsive">
                <table className="table align-items-center table-hover mb-0" style={FORM_LIBRARY_STYLES.table}>
                  <thead>
                    <tr>
                      <th style={FORM_LIBRARY_STYLES.tableHeadCell}></th>
                      <th style={FORM_LIBRARY_STYLES.tableHeadCell}>Date & Time</th>
                      <th style={FORM_LIBRARY_STYLES.tableHeadCell}>Review Officer</th>
                      <th style={FORM_LIBRARY_STYLES.tableHeadCell}>View / Edit Forms</th>
                      <th style={FORM_LIBRARY_STYLES.tableHeadCell}>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {appFormLibrary.length > 0 ? appFormLibrary.map((item, key) => (
                      <tr key={item.id || key}>
                        <td style={FORM_LIBRARY_STYLES.cell}>
                          <span style={FORM_LIBRARY_STYLES.serialBadge}>{key + 1}</span>
                        </td>
                        <td style={FORM_LIBRARY_STYLES.cell}>
                          <div style={FORM_LIBRARY_STYLES.dateText}>
                            <Moment format="MM-DD-YYYY">
                              {item.createdDateTime}
                            </Moment>
                          </div>
                          <div style={FORM_LIBRARY_STYLES.timeText}>
                            <Moment format="h:mm a">
                              {item.createdDateTime}
                            </Moment>
                          </div>
                        </td>
                        <td style={FORM_LIBRARY_STYLES.cell}>
                          <div style={FORM_LIBRARY_STYLES.personName}>{item.performerName}</div>
                          {item.email && <div style={FORM_LIBRARY_STYLES.metaLine}>{item.email}</div>}
                          {(item.performerRole || item.department || item.partner) &&
                            <div style={FORM_LIBRARY_STYLES.metaLine}>
                              {[item.performerRole, item.department, item.partner].filter(Boolean).join(" | ")}
                            </div>}
                        </td>
                        <td style={FORM_LIBRARY_STYLES.cell}>
                          <button
                            style={FORM_LIBRARY_STYLES.viewButton}
                            onClick={() => handleFormShowHide(item)}
                          >
                            Open Form
                            {item.updatedCount > 0 &&
                              <span style={FORM_LIBRARY_STYLES.updateBadge}>
                                {item.updatedCount}
                              </span>}
                          </button>
                        </td>
                        <td style={FORM_LIBRARY_STYLES.cell}>
                          <div style={FORM_LIBRARY_STYLES.remarksText}>{item.remarks || "No remarks added."}</div>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="5" style={{ ...FORM_LIBRARY_STYLES.cell, padding: 0 }}>
                          <div style={FORM_LIBRARY_STYLES.emptyState}>
                            <div style={FORM_LIBRARY_STYLES.emptyIcon}>
                              <i className="fa fa-files-o" aria-hidden="true"></i>
                            </div>
                            <div style={FORM_LIBRARY_STYLES.emptyTitle}>No forms available</div>
                            <div style={FORM_LIBRARY_STYLES.emptyText}>
                              Shared forms will appear here once a reviewer sends them to your workflow. When available, you can open and review them from this library.
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ViewFormModal
        viewFormShowHide={viewFormShowHide}
        handleViewForm={handleFormShowHide}
        workflowTask={wfTask}
        selectedForm={selectedForm}
        handleFormUpdate={handleFormUpdate}
        allowEdit={true}
      ></ViewFormModal>
    </React.Fragment>
  );
}

export default FormLibrary;
